import { sendRequest } from "../sendRequest";

export const unlinkAccount = (fundAccountId) => {
  return sendRequest(
    "delete",
    `/influencer/wallet/razorpay/unlink-account?fundAccountId=${fundAccountId}`
  ).then((res) => res.data);
};
